import ListItemSecondaryAction, { ListItemSecondaryActionProps } from '@material-ui/core/ListItemSecondaryAction';

export type DSListItemSecondaryActionProps = ListItemSecondaryActionProps;

export const DSListItemSecondaryAction = ListItemSecondaryAction;
